import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CartType, FullPalletUpgrade } from '../../../../core/model';
import { FullPalletUpgradeConnector } from '../connector/full-pallet-upgrade.connector';
import { FullPalletUpgradeFacade } from '../facades';

@Injectable()
export class FullPalletUpgradeService implements FullPalletUpgradeFacade {
  constructor(private fullPalletUpgradeConnector: FullPalletUpgradeConnector) {}

  load(userId: string, cartType: CartType, entryNumber: string): Observable<FullPalletUpgrade> {
    return this.fullPalletUpgradeConnector.load(userId, cartType, entryNumber);
  }
}
